import { classNames } from 'src/helpers/utilities'

type IndicatorProps = {
  name: string
  step: number
  totalSteps: number
  status: 'complete' | 'current' | 'upcoming'
}

export default function Indicator({ name, step, totalSteps, status }: IndicatorProps) {
  return (
    <div
      className={classNames(
        'text-left pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-2 md:pb-0 md:border-l-0 md:border-t-4',
        status === 'complete' ? 'border-brand-500' : '',
        status === 'current' ? 'border-brand-500 animate-pulse' : '',
        status === 'upcoming' ? 'border-gray-400' : ''
      )}
      aria-current="step"
    >
      <span
        className={classNames(
          'text-xs font-semibold tracking-wide uppercase',
          status === 'complete' ? 'text-brand-500' : '',
          status === 'current' ? 'text-brand-600' : '',
          status === 'upcoming' ? 'text-gray-400' : ''
        )}
      >
        {step} of {totalSteps}
      </span>
      <span
        className={classNames(
          'text-xs font-medium',
          status === 'complete' ? 'text-gray-500' : '',
          status === 'current' ? 'text-gray-500' : '',
          status === 'upcoming' ? 'text-gray-400' : ''
        )}
      >
        {name}
      </span>
    </div>
  )
}
